
export default [{
	path: '/products-pricing',
	component: () => import('@/components/products-pricing/List')
}]
